<template>
    <div class="users-style">
        
        <div class="table-style">
            <input class="input" type="text" v-model="search" placeholder="Search..."@input="filteredUsers()" style="width: 250px;">
            
        </div>

        <table class="table table-bordered table-responsive">
            
            <tbody>
                <tr v-for="user in paginatedUsers" :key="user.id">
                    <td>{{user.id}}</td>
                    <td>{{user.name}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.phone}}</td>
                    <td>{{user.created_at}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default 
    {     
        data() 
        {
            return {
                    users: [],
                    paginatedUsers:[],
                    sortKey: 'created_at',
                    search: '',
                }
        },
        methods: 
        {
            
            getUsers() 
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/all-admin-user/', {params: this.tableShow}).
                    then(response => {
                            //console.log('The data: ', response.data);
                            this.users = response.data;
                            this.paginatedUsers = this.users;
                            }
                        ).catch(errors => {console.log(errors);});
            },
            filteredUsers() 
            {
                let users = this.users;
                if (this.search) 
                {
                    users = users.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                
                this.paginatedUsers = users;
            },
        },
        created() 
        {
            this.getUsers();
        },
    };
</script>